module.exports = __webpack_public_path__ + "img/261.visibility_problem.944556e9.svg";